import { createContext } from 'react'

const RecipeIngredientsContentContext = createContext<boolean>(false)

export default RecipeIngredientsContentContext
